import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

function ensureMeta(selector, attrs) {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  return el;
}

const SeoManager = () => {
  const location = useLocation();
  const [seo, setSeo] = useState(null);
  const abortRef = useRef();

  const apiBase = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '';

  useEffect(() => {
    const controller = new AbortController();
    abortRef.current = controller;
    const path = location.pathname || '/';

    if (path.startsWith('/admin')) {
      setSeo(null);
      return () => controller.abort();
    }

    (async () => {
      try {
        const res = await fetch(`${apiBase}/backend/api.php?action=getPagesSeo&path=${encodeURIComponent(path)}`, { signal: controller.signal });
        const data = await res.json();
        setSeo(data && Object.keys(data).length ? data : null);
      } catch (e) {
        if (e.name !== 'AbortError') setSeo(null);
      }
    })();
    return () => controller.abort();
  }, [location.pathname]);

  useEffect(() => {
    if (!seo) return; // do not override defaults if no record
    if (seo.title) document.title = seo.title;

    // Description
    if (seo.description !== undefined && seo.description) {
      const desc = ensureMeta('meta[name="description"]', { name: 'description' });
      desc.setAttribute('content', seo.description);
    } else if (seo.description === '') {
      // Remove meta description if empty
      const existing = document.querySelector('meta[name="description"]');
      if (existing) existing.remove();
    }

    // Keywords
    if (seo.keywords !== undefined && seo.keywords) {
      const kw = ensureMeta('meta[name="keywords"]', { name: 'keywords' });
      kw.setAttribute('content', seo.keywords);
    } else if (seo.keywords === '') {
      // Remove meta keywords if empty
      const existing = document.querySelector('meta[name="keywords"]');
      if (existing) existing.remove();
    }

    // OG Title
    if (seo.title !== undefined && seo.title) {
      const ogt = ensureMeta('meta[property="og:title"]', { property: 'og:title' });
      ogt.setAttribute('content', seo.title);
    } else if (seo.title === '') {
      // Remove OG title if empty
      const existing = document.querySelector('meta[property="og:title"]');
      if (existing) existing.remove();
    }

    // OG Description
    if (seo.description !== undefined && seo.description) {
      const ogd = ensureMeta('meta[property="og:description"]', { property: 'og:description' });
      ogd.setAttribute('content', seo.description);
    } else if (seo.description === '') {
      // Remove OG description if empty
      const existing = document.querySelector('meta[property="og:description"]');
      if (existing) existing.remove();
    }

    // OG Image
    if (seo.og_image !== undefined && seo.og_image) {
      const ogi = ensureMeta('meta[property="og:image"]', { property: 'og:image' });
      ogi.setAttribute('content', seo.og_image);
    } else if (seo.og_image === '') {
      // Remove OG image if empty
      const existing = document.querySelector('meta[property="og:image"]');
      if (existing) existing.remove();
    }

    // Robots
    if (seo.noindex !== undefined) {
      const robots = ensureMeta('meta[name="robots"]', { name: 'robots' });
      robots.setAttribute('content', seo.noindex ? 'noindex, nofollow' : 'index, follow');
    }
  }, [seo]);

  return null;
};

export default SeoManager;


